import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { Instructor } from "../../typings/Instructor";
import { SliceStatus } from "../utils";
import instructorsApi from "./instructorsApi";

export const instructorsAdapter = createEntityAdapter<Instructor>();

const initialState = instructorsAdapter.getInitialState<{
  status: SliceStatus;
}>({
  status: SliceStatus.IDLE,
});

export const getInstructors = createAsyncThunk(
  "instructors/getInstructors",
  instructorsApi.getInstructors
);

export const instructorsSlice = createSlice({
  name: "instructors",
  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getInstructors.pending, (state) => {
      state.status = SliceStatus.LOADING;
    });

    builder.addCase(getInstructors.fulfilled, (state, { payload }) => {
      instructorsAdapter.upsertMany(state, payload);
      state.status = SliceStatus.IDLE;
    });

    builder.addCase(getInstructors.rejected, (state) => {
      state.status = SliceStatus.FAILED;
    });
  },
});

export default instructorsSlice.reducer;
